
    import Vue from "vue";
    import { Prop, Watch, Component } from "vue-property-decorator";
    import { mask } from 'vue-the-mask';

    @Component( {
        name: "Componente",
        directives: { mask },
        props: {},
        components: {}
    } )
    export default class Componente extends Vue {

        @Prop( { type: Number } ) public Porcentaje: number;
    }
